import {LEARNING_PATH_CSAT_ID} from 'containers/SatisfactionRating';
import {fetchLearningPathDetailsService} from 'store/services/learningPathServices';
import {fetchPedagogicalContentByIdService} from 'store/services/pedagogicalContentServices';
import {fetchQuestionnaireByIdService} from 'store/services/questionnaireServices';
import downloadWriteActivity, {
  DownloadStatus,
} from 'utils/functions/downloadWriteActivity';
import {LearningPathNestedStep} from 'utils/types/learningPath';
import downloadThirdPartyImages from '../downloadThirdPartyImages';

export async function writeActivityToDownload(
  learningPathId: number,
  step: LearningPathNestedStep,
): Promise<void> {
  const {
    data: {test},
  } = await fetchLearningPathDetailsService(learningPathId, step?.order);

  const downloadWriteActivityResult = await downloadWriteActivity({
    testId: Number(test?.id),
    themeId: test?.theme_id,
    usesWritePreparation: test?.uses_write_preparation,
    stepId: step.id,
    testCompositionId: step.activity_id,
  });

  if (downloadWriteActivityResult.error) {
    // TODO: Wait for the failure modal design and
    // throw a Error when the write creation fails
    // and it is not a rewrite.
  }
}

async function downloadLearningPath(
  learningPathId: number,
  steps: LearningPathNestedStep[] = [],
  getOpinion = false,
): Promise<DownloadStatus> {
  const requestsByStep = steps.map<Promise<unknown>>(async (step) => {
    switch (step.activity_type) {
      default:
        return writeActivityToDownload(learningPathId, step);

      case 'questionnaire':
        return fetchQuestionnaireByIdService(step.activity_id ?? 0).then(
          async ({data: questionnaire}) => {
            await downloadThirdPartyImages(questionnaire);
          },
        );

      case 'pedagogical content':
        return fetchPedagogicalContentByIdService(step.activity_id ?? 0).then(
          async ({data: pedagogicalContent}) => {
            await downloadThirdPartyImages(pedagogicalContent);
          },
        );
    }
  });

  try {
    await Promise.all(requestsByStep);

    if (getOpinion) {
      await fetchQuestionnaireByIdService(LEARNING_PATH_CSAT_ID);
    }

    return {
      message: 'Trilha baixada com sucesso',
      success: true,
    };
  } catch (error) {
    return {
      message: 'Não foi possivel baixar a trilha',
      error: true,
    };
  }
}

export default downloadLearningPath;
